import React,{useState,useEffect} from 'react'
import Nav from './Nav'

function Main({active,children}) {
    const [isMenuActive, setIsMenuActive] = useState(false);
    
    const toggleMenu = () =>{
        var element = document.getElementById("root");
        element.classList.toggle("mobile-nav-active");
        setIsMenuActive(!isMenuActive);
    }

    useEffect(() =>{
        var element = document.getElementById("root");
        element.classList = [];
    },[]);
    return (
        <>
            <Nav active={active}/>
            <div>
                <button type="button" onClick={toggleMenu} className="mobile-nav-toggle d-xl-none collapse-btn">
                    {
                        isMenuActive ?<i className="bx bx-x" id="menuSection"></i> : <i className="bx bx-menu" id="menuSection"></i>
                    }
                </button>
                {children}
            </div>
        </>
    )
}

export default Main
